export default function SpinnerSmall({ blue }) {
  return (
    <div className="flex items-center justify-center w-fit mr-auto">
      <div className="mx-auto w-[70px] text-center">
        <div
          className={`w-[10px] h-[10px] rounded-full inline-block animate-spinner-bounce ${
            blue ? "bg-altblue-500" : "bg-white"
          }`}
          style={{ animationDelay: "-0.32s" }}
        ></div>
        <div
          className={`w-[10px] h-[10px] rounded-full inline-block animate-spinner-bounce ${
            blue ? "bg-altblue-500" : "bg-white"
          }`}
          style={{ animationDelay: "-0.16s" }}
        ></div>
        <div
          className={`w-[10px] h-[10px] rounded-full inline-block animate-spinner-bounce ${
            blue ? "bg-altblue-500" : "bg-white"
          }`}
        ></div>
      </div>
    </div>
  );
}


